"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[821],{

/***/ 4821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ServiceContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4078);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var types_business_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3345);
/* harmony import */ var hooks_useFetch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9350);





const ServicesList = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(228), __webpack_require__.e(41), __webpack_require__.e(832), __webpack_require__.e(398), __webpack_require__.e(181), __webpack_require__.e(639)]).then(__webpack_require__.bind(__webpack_require__, 6594)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6594)
            ]
    },
    ssr: true
});
const ServicesCategorized = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(228), __webpack_require__.e(41), __webpack_require__.e(832), __webpack_require__.e(169), __webpack_require__.e(507), __webpack_require__.e(817)]).then(__webpack_require__.bind(__webpack_require__, 9817)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9817)
            ]
    },
    ssr: true
});
function ServiceContainer(param) {
    let { services  } = param;
    const { data: businessProfile  } = (0,hooks_useFetch__WEBPACK_IMPORTED_MODULE_4__/* .useBusinessProfile */ .jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data.widget;
    const { renderMethod , defaultOfferingSorting , offeringsSettings  } = (widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.settings.service) || {};
    if (services.items.length > 0) {
        /* Render method may be categorized (on API) but appears as Plain - Check businessProfile.ssr.ts */ if (renderMethod === types_business_types__WEBPACK_IMPORTED_MODULE_3__/* .RenderMethod.Categorized */ .zT.Categorized) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ServicesCategorized, {
                services: services,
                sorting: defaultOfferingSorting,
                serviceSettings: offeringsSettings
            });
        } else if (renderMethod === types_business_types__WEBPACK_IMPORTED_MODULE_3__/* .RenderMethod.Plain */ .zT.Plain) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ServicesList, {});
        }
    }
    return null;
}


/***/ })

}]);